

import { Button, Checkbox, Container, Form, FormField, Grid, Input, Link, Popover, Table } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';
import React, { useEffect, useRef, useState } from 'react';
import { CustomAppLayout } from '../../../layout';
const _preserve = React.version;

//import { useStoreAdmin } from '../../../../context/useStoreAdmin';
import { mdiCheckCircle } from '@mdi/js';
import Icon from '@mdi/react';
import Favorites from '../../../../../components/extras/Favorites';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { addNotificationStatus, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading } from '../../../../commons/functions';
import { useGlobalState } from '../../../../context/GlobalStateContext';
import { ItemCategory } from '../../comm/news/list';


export const MasterEquipmentsCategoriesPage = () => {
    const { menu } = useGlobalState();

    const [category, setCategory] = useState<ItemCategory>()
    const [categories, setCategories] = useState<ItemCategory[]>([])



    const mountedRef = useRef(false);
    useEffect(() => {
        const handleHashChange = () => {
            const hash = window.location.hash;
            const params = new URLSearchParams(hash.split("?")[1]);
            const id = params.get("id");
            if (id) {
                setCategory(undefined)
                handleGetCategoryDetail(parseInt(id))
            } else {
                setCategory(undefined)
                handleGetCategories();
            }
        };

        window.addEventListener("hashchange", handleHashChange);
        // also trigger once on mount
        handleHashChange();

        return () => window.removeEventListener("hashchange", handleHashChange);
    }, []);

    const handleGetCategoryDetail = async (idCategory: number) => {
        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/equipments/categories/category',
                    'JWT': getCookie("JWT"),

                },

                body: JSON.stringify({ idCategory: idCategory })
            });
            if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

            const data = await response.json();
            if (data && data.category) {
                setCategory(data.category)
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    }
    const handleGetCategories = async () => {
        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/equipments/categories/list',
                    'JWT': getCookie("JWT"),

                },

                body: JSON.stringify({ columns: "*" })
            });
            if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

            const data = await response.json();
            if (data && data.categories)
                setCategories(data.categories)
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleSaveCategory = async () => {
        try {

            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/equipments/categories/update',
                    'JWT': getCookie("JWT"),

                },

                body: JSON.stringify(category)
            });
            if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

            const data = await response.json();

            addNotificationStatus(data, setData);
            if (data.code === 0) {
                window.location.hash = "#masters/equipments/categories"

            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false)
        }
    };
    useEffect(() => {
        //handleGetGroups()

    }, []);

    //setIdGroupType(item.idGroupType)





    return (
        <CustomAppLayout
            toolsHide


            contentType="form"
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween direction='vertical' size="l">

                    {!!category && (
                        <SpaceBetween direction='vertical' size="l">
                            <Header
                                description={`ID ${category?.idCategory}`}
                                actions={
                                    <SpaceBetween direction="horizontal" size="l">
                                        <Button variant="link" onClick={() => window.location.hash = "#masters/equipments/categories"}>
                                            Cancelar
                                        </Button>
                                        <Favorites />
                                    </SpaceBetween>

                                }>Detalle de categoría {category.category}</Header>
                            <Form actions={
                                <Button variant="primary" onClick={handleSaveCategory}>
                                    Guardar
                                </Button>
                            }>

                                <Container>
                                    <SpaceBetween direction='vertical' size='xs'>
                                        <Grid gridDefinition={[{ colspan: 6 }, { colspan: 3 }, { colspan: 3 }]}>
                                            <div>
                                                <FormField label={"Categoría"}>
                                                    <Input value={category?.category || ""}
                                                        onChange={(detail) => {
                                                            setCategory((prev) =>
                                                                prev ? { ...prev, category: detail.detail.value.toUpperCase() } : prev
                                                            );
                                                        }}
                                                    />
                                                </FormField>
                                            </div>

                                        </Grid>
                                        <SpaceBetween direction='horizontal' size='xs'>
                                            <div style={{ width: 500 }}>
                                                <FormField label="Tiene alturas de remolque" constraintText="Define si el grupo de aeronaves maneja alturas de remolque">
                                                    <Checkbox checked={category?.hasAltitudes === 1} onChange={(event) => {
                                                        setCategory((prev) =>
                                                            prev ? { ...prev, hasAltitudes: event.detail.checked ? 1 : 0 } : prev
                                                        );
                                                    }}>
                                                        Activo
                                                    </Checkbox>
                                                </FormField>
                                            </div>
                                        </SpaceBetween>

                                        <SpaceBetween direction='horizontal' size='xs'>
                                            <div style={{ width: 250 }}>
                                                <FormField label="Umbral prevuelo" constraintText="Horas antes del vuelo para considerar como prevuelo">
                                                    <Input type="number" value={category?.thresholdBefore.toString() || "1"} onChange={(event) => {
                                                        setCategory((prev) =>
                                                            prev ? { ...prev, thresholdBefore: Number(event.detail.value) } : prev
                                                        );
                                                    }} />
                                                </FormField>
                                            </div>
                                            <div style={{ width: 250 }}>
                                                <FormField label="Umbral postvuelo" constraintText="Horas despues del vuelo para considerar como postvuelo">
                                                    <Input type="number" value={category?.thresholdAfter.toString() || "1"} onChange={(event) => {
                                                        setCategory((prev) =>
                                                            prev ? { ...prev, thresholdAfter: Number(event.detail.value) } : prev
                                                        );
                                                    }} />
                                                </FormField>
                                            </div>

                                        </SpaceBetween>


                                    </SpaceBetween>
                                </Container>
                            </Form>
                        </SpaceBetween>
                    )}
                    {!category && (
                        <SpaceBetween direction="vertical" size="xs">
                            <Header actions={<Favorites />}>Categorías de material</Header>
                            <Table
                                variant="embedded"

                                columnDefinitions={[
                                    {
                                        id: "category",
                                        header: "Categoría",
                                        cell: item => <Link onClick={() => {

                                            window.location.hash = `#masters/equipments/categories?id=${item.idCategory}`

                                        }}>{item.category}</Link>,
                                    },
                                    {
                                        id: "altitudes",
                                        header: <Popover triggerType="custom" dismissButton={false} content="Categoría tiene altitudes registradas">ADR</Popover>,
                                        cell: item => item.hasAltitudes === 1 ? <Icon path={mdiCheckCircle} size={1} /> : "",
                                    },
                                    {
                                        id: "thresholdBefore",
                                        header: "Pre vuelo",
                                        cell: item => item.thresholdBefore > 9 ? item.thresholdBefore : `Sin pre vuelo`,
                                    },
                                    {
                                        id: "thresholdAfter",
                                        header: "Post vuelo",
                                        cell: item => item.thresholdAfter > 9 ? item.thresholdAfter : `Sin post vuelo`,
                                    },
                                ]}
                                items={categories ?? []}
                            />
                        </SpaceBetween>

                    )}
                </SpaceBetween>
            }

        />
    );
};


